import { z } from 'zod'

export const callQualityWizardIssueFormIssues = [
  'choppy_audio',
  'delayed_audio',
  'dropped_calls',
  'one_way_audio',
  'other',
] as const

export type CallQualityWizardIssueFormIssueType =
  (typeof callQualityWizardIssueFormIssues)[number]

export const callQualityWizardIssueFormIssue = {
  choppy_audio: 'Choppy audio',
  delayed_audio: 'Delayed audio',
  dropped_calls: 'Dropped calls',
  one_way_audio: 'One-way audio',
  other: 'Other issue',
} as const

export type CallQualityWizardIssueFormSubmissionSchema = {
  type: 'issue'
  payload: CallQualityWizardIssueFormSchema
}

export const callQualityWizardIssueFormSchema = z.object({
  issue: z.enum(callQualityWizardIssueFormIssues),
  issueText: z.string().optional(),
})

export type CallQualityWizardIssueFormSchema = z.infer<
  typeof callQualityWizardIssueFormSchema
>
